import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import { createPinia } from 'pinia';
import UniqueId from './vue/plugins/vue-unique-id.js';

import commentService from './vue/plugins/commentservice.js';
import staffservice from './vue/plugins/staffservice.js';

import comments from './vue/comments.vue';
import staffcatalog from './vue/staffcatalog/staffcatalog.vue';
import AstaSearch from './vue/Asta/AstaSearch.vue';
import AstaResult from './vue/Asta/AstaResult.vue';

var VuecomponentList = [
  { container: 'comments', component: comments },
  { container: 'staffcatalog', component: staffcatalog },
  { container: 'asta-search', component: AstaSearch },
  { container: 'asta-result', component: AstaResult },
];

function initVueComponent(item: any) {
  var pagebottomTAG = item.container,
    pagebottomDOMs = document.querySelectorAll(pagebottomTAG);
  pagebottomDOMs.forEach((pagebottomDOM) => {
    if (pagebottomDOM) {
      var rawoptions = pagebottomDOM.getAttribute('data-settings'),
        options = {};
      if (rawoptions) {
        options = JSON.parse(rawoptions);
      }
      if (item.container == 'staffcatalog') {
        const routes = [{ path: '/', component: staffcatalog, default: true }];
        const router = createRouter({ history: createWebHistory(), routes: routes }); // new VueRouter({ routes });
        createApp(item.component, { ...options })
          .use(router)
          .use(createPinia())
          .use(staffservice)
          .mount(item.container);
      } else if (item.container == 'asta-search') {
        createApp(item.component, { ...options }).mount(item.container);
      } else {
        createApp(item.component, { ...options })
          .use(createPinia())
          .use(commentService)
          .use(UniqueId)
          .mount(item.container);
      }
    }
  });
}

uhr.ready((_w, _$) => {
  VuecomponentList.forEach((item) => {
    initVueComponent(item);
  });
});
